<template>
  <v-app>
    <UpgradeBanner />
    <NavBar />
    <v-main>
      <router-view />
    </v-main>
    <notifications position="bottom right" />
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

const updateBadgeVisibility = (hidden: boolean) => {
  document.body.classList.toggle("hide-recaptcha-badge", hidden);
};

onMounted(() => {
  updateBadgeVisibility(true);
});
</script>

<style>
@media (max-width: 600px) {
  .v-application .v-row {
    margin: 0 !important;
  }
  .v-application .v-row > * {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

.hide-recaptcha-badge .grecaptcha-badge {
  display: none !important;
}

.v-tooltip > .v-overlay__content {
  background: #fff !important;
  color: #1e293b !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
}

.v-field--variant-outlined:not(.v-field--focused) .v-field__outline {
  color: rgba(0, 0, 0, 0.18) !important;
}
.v-field--variant-outlined:not(.v-field--focused):hover .v-field__outline {
  color: rgba(0, 0, 0, 0.32) !important;
}
</style>
